import {Injectable} from 'ng-metadata/core';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';


@Injectable()
export class HighlightsService {
    private _highlights;
    constructor(private configurationUtil : ConfigurationUtil) {
    }
    
    get highlights() {
        return this._highlights;
    }
    
    set highlights(highlights) {
        this._highlights = highlights;
    }
    
    public updateHighlights(items) {
        if (!items) {
            return;
        }
        

        this.highlights=items;
        
    }
    
    private getFieldsFromHighlightsAsArray(item) {
	    let ret = {};
	    ret[item.field] = item.terms;
	        return ret;
	    }
    

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/highlight/highlight.service.ts